import React, { useEffect } from 'react'
import { VehicleDetailsDataObject } from '../../services/vehicle-service'
import { scrollToTheTop } from '../Questions/utils'
import withFade from '../HOC/withFade'
import SimpleVehicleCard from './SimpleVehicleCard'


interface VehicleHeaderProps {
  vehicle: VehicleDetailsDataObject
}

const VehicleHeader = ({ vehicle }: VehicleHeaderProps) => {
  useEffect(scrollToTheTop, [])
  return (
    <SimpleVehicleCard
      vehicle={vehicle}
      vehicleImg={vehicle?.imageUrls?.[0]}
    />
  )
}

export default withFade(VehicleHeader)
